/**
 * Created by JackCui on 2021/12/2
 */

export default function pageSchemaHandle () {
  return {
    _type: 'page',
    viewComponentName: 'page-render'
  }
}

// viewContent: [
//   {
//     _type: 'header'
//   },
//   {
//     _type: 'form',
//     viewContent: [
//       ...node.viewContent
//     ]
//   },
//   {
//     _type: 'footer'
//   }
// ]
